import { render, staticRenderFns } from "./confirmDialogNew.vue?vue&type=template&id=39560796&scoped=true&"
import script from "./confirmDialogNew.vue?vue&type=script&lang=js&"
export * from "./confirmDialogNew.vue?vue&type=script&lang=js&"
import style0 from "./confirmDialogNew.vue?vue&type=style&index=0&id=39560796&lang=less&scoped=true&"
import style1 from "./confirmDialogNew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39560796",
  null
  
)

export default component.exports